const authEventTarget = new EventTarget();

export default authEventTarget;